import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4217ec69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "faq__display-title" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "faq__validation-errors" }
const _hoisted_5 = { class: "faq__fields" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-sm" }, "Tittel", -1))
const _hoisted_7 = { class: "field-error" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-sm" }, "Kategori", -1))
const _hoisted_9 = { class: "field-error" }
const _hoisted_10 = { class: "faq__editor" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-sm" }, "Beskrivelse", -1))
const _hoisted_12 = { class: "field-error" }
const _hoisted_13 = { class: "faq__buttons" }
const _hoisted_14 = { class: "py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_levels_select = _resolveComponent("levels-select")!
  const _component_MarkdownEditor = _resolveComponent("MarkdownEditor")!
  const _component_HcButton = _resolveComponent("HcButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "main-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_Messages, { class: "attribute-index-messages" }),
      _createVNode(_component_Card, { class: "faq" }, {
        default: _withCtx(() => [
          (_ctx.faq)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
                _createTextVNode(" Rediger FAQ: "),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.faq.title), 1)
              ]))
            : (_openBlock(), _createElementBlock("h1", _hoisted_3, "Ny FAQ")),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ValidationFormErrors, {
              errors: _ctx.form.errors as any
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                class: "w-full form-input",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                id: "title"
              }, null, 512), [
                [_vModelText, _ctx.form.title]
              ]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.form.errors.title), 1)
            ]),
            _createElementVNode("label", null, [
              _hoisted_8,
              (_openBlock(), _createBlock(_component_levels_select, {
                key: _ctx.form.faq_category_id,
                limit: 100,
                placeholder: 'Velg kategori',
                options: _ctx.options,
                onSelectOption: _ctx.selectOption,
                modelValue: _ctx.form.faq_category_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.faq_category_id) = $event))
              }, null, 8, ["options", "onSelectOption", "modelValue"])),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.form.errors.faq_category_id), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, [
              _hoisted_11,
              _createVNode(_component_MarkdownEditor, {
                mediable: _ctx.mediable,
                attachmentEndpoint: '/attachments',
                modelValue: _ctx.form.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
                onUploadingImages: _ctx.uploadingImages,
                editorOptions: { min_height: 400 },
                extensions: { image: true,  table: true}
              }, null, 8, ["mediable", "modelValue", "onUploadingImages"]),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.form.errors.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_HcButton, {
              disabled: _ctx.isUploadingImages,
              onClick: _ctx.submit,
              color: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Lagre")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_HcButton, {
              onClick: _ctx.abort,
              color: "gray"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Avbryt")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_HcButton, {
              onClick: _ctx.reset,
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Nullstille")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Checkbox, {
                label: "Ikke ferdigstilt",
                modelValue: _ctx.form.is_draft,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.is_draft) = $event)),
                errorMessage: _ctx.form.errors.is_draft
              }, null, 8, ["modelValue", "errorMessage"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}